// import React from 'react';

// const BusRatesTable = () => {
//   const ratesData = [
    
//     { seater: "SWIFT DESIRE", mumbai: "4+1", mahabaleshwar: "12", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//     { seater: "AURA", mumbai: "4+1", mahabaleshwar: "12", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//     { seater: "TOYOTA ETIOS", mumbai: "4+1", mahabaleshwar: "14", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//     { seater: "ERITGA", mumbai: "6+1", mahabaleshwar: "15", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//     { seater: "SCORPIO", mumbai: "8+1", mahabaleshwar: "18", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//     { seater: "INNOVA CRYSTA", mumbai: "6+1", mahabaleshwar: "20", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//     { seater: "TEMPO TRAVELLER", mumbai: "13/17 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//     { seater: "URBANIA", mumbai: "13/17 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//     { seater: "MINI BUS", mumbai: "20 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//     { seater: "BUS", mumbai: "32-52", mahabaleshwar: "ON CALL", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//     { seater: "KIA Carens", mumbai: "6+1/7+1", mahabaleshwar: "17/KM & 18/KM", specialPermitNumber: "919272511548", driver: "Extra", parking: "Extra" },
//   ];

//   const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     margin: "20px auto",
//   };

//   const thStyle = {
//     backgroundColor: "#FF681A",
//     color: "white",
//     padding: "8px",
//     border: "1px solid #ddd",
//   };

//   const tdStyle = {
//     padding: "8px",
//     border: "1px solid #ddd",
//     textAlign: "center",
//   };

//   const trEvenStyle = {
//     backgroundColor: "#f2f2f2",
//   };

//   const handleWhatsAppClick = (number, seater) => {
//     console.log(`Opening WhatsApp for ${seater} with number ${number}`);
//     const message = `Good day, I am interested in booking ${seater}. Kindly provide the availability, pricing, and booking procedure.`;
//     const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
//     window.open(url, '_blank');
//   };

//   return (
//     <div className="container p-0">
//       <div className="table-responsive">
//         <table style={tableStyle}>
//           <thead>
//             <tr>
//               <th style={thStyle}>Bus Name</th>
//               <th style={thStyle}>Seater</th>
//               <th style={thStyle}>Per KM</th>
//               <th style={thStyle}>Driver Food</th>
//               <th style={thStyle}>Toll Parking</th>
//               <th style={thStyle}>Book Now</th>
//             </tr>
//           </thead>
//           <tbody>
//             {ratesData.map((row, index) => (
//               <tr key={index} style={index % 2 === 0 ? trEvenStyle : null}>
//                 <td style={tdStyle}>{row.seater}</td>
//                 <td style={tdStyle}>{row.mumbai}</td>
//                 <td style={tdStyle}>{row.mahabaleshwar}</td>
//                 <td style={tdStyle}>{row.driver}</td>
//                 <td style={tdStyle}>{row.parking}</td>
//                 <td style={tdStyle}>
//                   <button
//                     onClick={() => handleWhatsAppClick(row.specialPermitNumber, row.seater)}
//                     style={{
//                       cursor: "pointer",
//                       backgroundColor: "#FF681A",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       color: "white",
//                     }}
//                   >
//                     Book Now
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>


//     </div>
//   );
// };

// export default BusRatesTable;













// import React from "react";
// import "@fortawesome/fontawesome-free/css/all.min.css";

// const BusRatesTable = () => {
//   const ratesData = [
//     {
//       vehicle: "SWIFT DZIRE",
//       seater: "4+1",
//       perKm: "12",
//       whatsapp: "919272511548",
//       driver: "Extra",
//       parking: "Extra",
//     },
//     {
//       vehicle: "AURA",
//       seater: "4+1",
//       perKm: "12",
//       whatsapp: "919272511548",
//       driver: "Extra",
//       parking: "Extra",
//     },
//     {
//       vehicle: "TOYOTA ETIOS",
//       seater: "4+1",
//       perKm: "14",
//       whatsapp: "919272511548",
//       driver: "Extra",
//       parking: "Extra",
//     },
//     {
//       vehicle: "ERTIGA",
//       seater: "6+1",
//       perKm: "15",
//       whatsapp: "919272511548",
//       driver: "Extra",
//       parking: "Extra",
//     },
//     {
//       vehicle: "SCORPIO",
//       seater: "8+1",
//       perKm: "18",
//       whatsapp: "919272511548",
//       driver: "Extra",
//       parking: "Extra",
//     },
//     {
//       vehicle: "INNOVA CRYSTA",
//       seater: "6+1",
//       perKm: "20",
//       whatsapp: "919272511548",
//       driver: "Extra",
//       parking: "Extra",
//     },
//     {
//       vehicle: "TEMPO TRAVELLER",
//       seater: "13 / 17",
//       perKm: "On Call",
//       whatsapp: "919272511548",
//       driver: "Extra",
//       parking: "Extra",
//     },
//     {
//       vehicle: "URBANIA VAN",
//       seater: "13 / 17",
//       perKm: "On Call",
//       whatsapp: "919272511548",
//       driver: "Extra",
//       parking: "Extra",
//     },
   
//     {
//       vehicle: "KIA CARENS",
//       seater: "6+1 / 7+1",
//       perKm: "17 / 18",
//       whatsapp: "919272511548",
//       driver: "Extra",
//       parking: "Extra",
//     },

//      {
//       vehicle: "MINI BUS",
//       seater: "20",
//       perKm: "On Call",
//       whatsapp: "919272511548",
//       driver: "Extra",
//       parking: "Extra",
//     },
//   ];

//   const handleWhatsAppClick = (number, vehicle) => {
//     const message = `Hello Rising Cab Service, I want to book ${vehicle}. Please share availability and pricing details.`;

//     window.open(
//       `https://wa.me/${number}?text=${encodeURIComponent(message)}`,
//       "_blank"
//     );
//   };

//   return (
//     <div className="container my-5">
//       {/* Header */}
   

//       {/* Table Card */}
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: "20px",
//           overflow: "hidden",
//           boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
//           border: "1px solid #eee",
//         }}
//       >
//         <div className="table-responsive">
//           <table
//             className="table mb-0"
//             style={{
//               verticalAlign: "middle",
//             }}
//           >
//             <thead>
//               <tr
//                 style={{
//                   background:
//                     "linear-gradient(135deg,#1E355E,#FF681A)",
//                   color: "#fff",
//                 }}
//               >
//                 <th className="text-center py-3">Vehicle</th>
//                 <th className="text-center py-3">Seater</th>
//                 <th className="text-center py-3">Per KM</th>
//                 <th className="text-center py-3">Driver Food</th>
//                 <th className="text-center py-3">Toll Parking</th>
//                 <th className="text-center py-3">Booking</th>
//               </tr>
//             </thead>

//             <tbody>
//               {ratesData.map((row, index) => (
//                 <tr
//                   key={index}
//                   style={{
//                     background:
//                       index % 2 === 0 ? "#F8FAFC" : "#FFFFFF",
//                   }}
//                 >
//                   <td className="text-center fw-bold text-primary">
//                     {row.vehicle}
//                   </td>

//                   <td className="text-center">
//                     <span
//                       style={{
//                         background: "#EAF4FF",
//                         color: "#1E355E",
//                         padding: "6px 12px",
//                         borderRadius: "30px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {row.seater}
//                     </span>
//                   </td>

//                   <td
//                     className="text-center fw-bold"
//                     style={{
//                       color: "#FF681A",
//                     }}
//                   >
//                     {row.perKm}
//                   </td>

//                   <td className="text-center">
//                     {row.driver}
//                   </td>

//                   <td className="text-center">
//                     {row.parking}
//                   </td>

//                   <td className="text-center">
//                     <button
//                       onClick={() =>
//                         handleWhatsAppClick(
//                           row.whatsapp,
//                           row.vehicle
//                         )
//                       }
//                       style={{
//                         background: "#25D366",
//                         color: "#fff",
//                         border: "none",
//                         borderRadius: "50px",
//                         padding: "10px 18px",
//                         fontWeight: "600",
//                         cursor: "pointer",
//                         transition: "0.3s",
//                       }}
//                     >
//                       <i className=" me-2"></i>
//                       Book&nbsp;Now
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Footer Note */}
//       <div
//         style={{
//           marginTop: "20px",
//           background: "#FFF4EC",
//           borderLeft: "5px solid #FF681A",
//           padding: "15px",
//           borderRadius: "10px",
//         }}
//       >
//         <strong>Note:</strong> Driver allowance, toll, parking,
//         permit and interstate taxes will be charged extra as
//         applicable.
//       </div>
//     </div>
//   );
// };

// export default BusRatesTable;







import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

const BusRatesTable = () => {
  const whatsappNumber = "919272511548";

  const outstationRates = [
    {
      vehicle: "Aura / Dzire",
      perKm: "₹12",
      minAvg: "300 Km",
      extraKm: "₹12",
      toll: "Extra",
      da: "₹300",
    },
    {
      vehicle: "Ertiga",
      perKm: "₹15",
      minAvg: "300 Km",
      extraKm: "₹15",
      toll: "Extra",
      da: "₹300",
    },
    {
      vehicle: "Innova Crysta",
      perKm: "₹20",
      minAvg: "300 Km",
      extraKm: "₹20",
      toll: "Extra",
      da: "₹300",
    },
    {
      vehicle: "Innova Hycross",
      perKm: "₹22",
      minAvg: "300 Km",
      extraKm: "₹22",
      toll: "Extra",
      da: "₹300",
    },
    // {
    //   vehicle: "Kia Carens",
    //   perKm: "₹17",
    //   minAvg: "300 Km",
    //   extraKm: "₹17",
    //   toll: "Extra",
    //   da: "₹300",
    // },
  ];

  const localCharges = [
    {
      vehicle: "Aura / Dzire",
      package: "8 Hrs / 80 Km",
      price: "₹2400",
      extraKm: "₹14",
    },
    {
      vehicle: "Ertiga",
      package: "8 Hrs / 80 Km",
      price: "₹3200",
      extraKm: "₹16",
    },
    {
      vehicle: "Innova Crysta",
      package: "8 Hrs / 80 Km",
      price: "₹4500",
      extraKm: "₹22",
    },
    {
      vehicle: "Innova Hycross",
      package: "8 Hrs / 80 Km",
      price: "₹5000",
      extraKm: "₹24",
    },
  ];

  const pickupDropCharges = [
    {
      vehicle: "Aura / Dzire",
      charge: "₹2800",
      details: "Toll Included",
    },
    {
      vehicle: "Ertiga",
      charge: "₹3500",
      details: "Toll Included",
    },
    {
      vehicle: "Innova Crysta",
      charge: "₹5000",
      details: "Toll Included",
    },
    {
      vehicle: "Innova Hycross",
      charge: "₹6000",
      details: "Toll Included",
    },
  ];

  const handleWhatsAppClick = (vehicle) => {
    const message = `Hello Rising Cab Service, I would like to book ${vehicle}. Please share availability and pricing details.`;

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  const cardStyle = {
    background: "#fff",
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0 10px 35px rgba(0,0,0,.08)",
    marginBottom: "35px",
  };

  const headerStyle = {
    background: "linear-gradient(135deg,#0A2F66,#FF681A)",
    color: "#fff",
    padding: "16px 20px",
    fontSize: "22px",
    fontWeight: "700",
  };

  const bookBtn = {
    background: "#25D366",
    color: "#fff",
    border: "none",
    padding: "8px 18px",
    borderRadius: "30px",
    cursor: "pointer",
    fontWeight: "600",
  };

  return (
    <div className="container my-5">
      {/* OUTSTATION CHARGES */}

      <div style={cardStyle}>
        <div style={headerStyle}>
          🚖 Outstation Per KM Charges
        </div>

        <div className="table-responsive">
          <table className="table mb-0 align-middle">
            <thead>
              <tr>
                <th>Vehicle</th>
                <th>Per KM</th>
                <th>Min Avg / Day</th>
                <th>Extra KM</th>
                <th>Toll Tax</th>
                <th>DA</th>
                <th>Book</th>
              </tr>
            </thead>

            <tbody>
              {outstationRates.map((item, index) => (
                <tr key={index}>
                  <td className="fw-bold">{item.vehicle}</td>

                  <td
                    className="fw-bold"
                    style={{ color: "#FF681A" }}
                  >
                    {item.perKm}
                  </td>

                  <td>{item.minAvg}</td>

                  <td>{item.extraKm}</td>

                  <td>{item.toll}</td>

                  <td>{item.da}</td>

                  <td>
                    <button
                      style={bookBtn}
                      onClick={() =>
                        handleWhatsAppClick(item.vehicle)
                      }
                    >
                      Book Now
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* LOCAL CHARGES */}

      <div style={cardStyle}>
        <div style={headerStyle}>
          📍 Local Charges
        </div>

        <div className="table-responsive">
          <table className="table mb-0 align-middle">
            <thead>
              <tr>
                <th>Vehicle</th>
                <th>Package</th>
                <th>Price</th>
                <th>Extra Per KM</th>
                <th>Book</th>
              </tr>
            </thead>

            <tbody>
              {localCharges.map((item, index) => (
                <tr key={index}>
                  <td className="fw-bold">
                    {item.vehicle}
                  </td>

                  <td>{item.package}</td>

                  <td
                    className="fw-bold"
                    style={{ color: "#FF681A" }}
                  >
                    {item.price}
                  </td>

                  <td>{item.extraKm}</td>

                  <td>
                    <button
                      style={bookBtn}
                      onClick={() =>
                        handleWhatsAppClick(item.vehicle)
                      }
                    >
                      Book Now
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* PICKUP DROP */}

      <div style={cardStyle}>
        <div style={headerStyle}>
          🌉 Mumbai - Pune Pickup / Drop Charges
        </div>

        <div className="table-responsive">
          <table className="table mb-0 align-middle">
            <thead>
              <tr>
                <th>Vehicle</th>
                <th>Charges</th>
                <th>Details</th>
                <th>Book</th>
              </tr>
            </thead>

            <tbody>
              {pickupDropCharges.map((item, index) => (
                <tr key={index}>
                  <td className="fw-bold">
                    {item.vehicle}
                  </td>

                  <td
                    className="fw-bold"
                    style={{
                      color: "#FF681A",
                      fontSize: "18px",
                    }}
                  >
                    {item.charge}
                  </td>

                  <td>{item.details}</td>

                  <td>
                    <button
                      style={bookBtn}
                      onClick={() =>
                        handleWhatsAppClick(item.vehicle)
                      }
                    >
                      Book Now
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* NOTE */}

      <div
        style={{
          background: "#FFF4EC",
          borderLeft: "5px solid #FF681A",
          padding: "18px",
          borderRadius: "10px",
        }}
      >
        <h6 className="mb-2">
          Important Information
        </h6>

        <ul className="mb-0">
          <li>
            Driver allowance (DA) ₹300/day extra.
          </li>
          <li>
            Toll, Parking, Permit & State Tax extra.
          </li>
          <li>
            Minimum 300 Km average applicable for
            outstation trips.
          </li>
          <li>
            Local package includes 8 Hours / 80 Km.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BusRatesTable;